export interface IUserClaims {
    id?: number
    claimType?: string,
    claimValue?: string,
}

export interface IUserProfile {
    id?: number;
    email: string;
    firstName: string;
    lastName: string;
    countryId: string;
    contactNumber?: string;
    birthDate?: Date;
    avatar?: string;
    tin?: string;
    
}

export class UserProfile implements IUserProfile{
    id?: number;
    email: string;
    firstName: string;
    lastName: string;
    countryId: string;
    contactNumber?: string;
    birthDate?: Date;
    avatar?: string;
    tin?: string

    [index: string]: string | Date | number | undefined

    constructor(user: IUserProfile) {
        this.email = user.email;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
        this.countryId = user.countryId;
        this.id = user.id;
        this.contactNumber = user.contactNumber;
        this.birthDate = user.birthDate;
        this.avatar = user.avatar;
        this.tin = user.tin;
    }
}

export interface UserProfileEdit {
    contactNumber: string,
    firstName: string,
    id: number,
    lastName: string,
    tin: string,
    birthDate: Date
}